import React, { useEffect, useState } from 'react';

const SubmitMessage = ({ survey, submittedData, questions = [] }) => {
    const [redirectTimer, setRedirectTimer] = useState(null);
    const [timeLeft, setTimeLeft] = useState(0);
    const [initialTime, setInitialTime] = useState(0);

    useEffect(() => {
        return () => {
            if (redirectTimer) clearInterval(redirectTimer);
        };
    }, [redirectTimer]);

    const handleRedirect = () => {
        if (survey.redirectUrl) {
            window.location.href = survey.redirectUrl;
        }
    };

    const startRedirectTimer = (redirectTime) => {
        let remaining = redirectTime || 5;
        setTimeLeft(remaining);
        setInitialTime(remaining);

        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleRedirect();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        setRedirectTimer(timer);
    };

    useEffect(() => {
        if (survey.redirectUrl && survey.redirectTimeAfterMessage > 0) {
            startRedirectTimer(survey.redirectTimeAfterMessage);
        } else if (survey.redirectUrl) {
            const timeout = setTimeout(handleRedirect, 100);
            return () => clearTimeout(timeout);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey.redirectUrl, survey.redirectTimeAfterMessage]);

    const calculateProgress = () => {
        if (initialTime === 0) return 100;
        return ((initialTime - timeLeft) / initialTime) * 100;
    };

    return (
        <div className="ecx-survey-preview">
            <div className="ecx-survey-preview__layout">
                <section className="ecx-survey-preview__form-panel">
                    <div className="ecx-survey-preview__paper ecx-survey-preview__paper--center">
                        <span className="ecx-survey-preview__complete-icon">
                            <i className="bi bi-check2-circle" />
                        </span>
                        <div
                            className="ecx-survey-preview__complete-message"
                            dangerouslySetInnerHTML={{
                                __html:
                                    survey.messageAfterComplete ||
                                    '<h3>Thank you for completing the survey!</h3><p>Your responses have been recorded.</p>',
                            }}
                        />

                        {survey.redirectUrl && survey.redirectTimeAfterMessage > 0 ? (
                            <div className="ecx-survey-preview__redirect mt-3">
                                <p className="text-muted small mb-2">
                                    Redirecting in {timeLeft} second{timeLeft !== 1 ? 's' : ''}…
                                </p>
                                <div className="progress ecx-survey-preview__progress-bar mb-3">
                                    <div
                                        className="progress-bar"
                                        style={{ width: `${calculateProgress()}%` }}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary rounded-pill"
                                    onClick={handleRedirect}
                                >
                                    Redirect now
                                </button>
                            </div>
                        ) : null}

                        {survey.redirectUrl &&
                        (!survey.redirectTimeAfterMessage ||
                            survey.redirectTimeAfterMessage <= 0) ? (
                            <div className="ecx-survey-preview__redirect mt-3">
                                <div className="spinner-border spinner-border-sm text-primary mb-2" />
                                <p className="text-muted small mb-2">Redirecting…</p>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary rounded-pill"
                                    onClick={handleRedirect}
                                >
                                    Continue
                                </button>
                            </div>
                        ) : null}
                    </div>
                </section>

                <aside className="ecx-survey-preview__side-panel">
                    <div className="ecx-survey-preview__side-card">
                        <div className="ecx-survey-preview__side-header">
                            <div>
                                <h3 className="ecx-survey-preview__side-title">Submitted answers</h3>
                                <p className="ecx-survey-preview__side-meta mb-0">Preview payload</p>
                            </div>
                        </div>
                        <div className="ecx-survey-preview__side-body">
                            {questions.length ? (
                                <ul className="ecx-survey-preview__answer-list">
                                    {questions.map((question, index) => {
                                        const value = submittedData?.[question.internalId];
                                        const hasValue =
                                            value !== undefined &&
                                            value !== null &&
                                            value !== '' &&
                                            !(Array.isArray(value) && value.length === 0);
                                        return (
                                            <li key={question.internalId || question.id}>
                                                <div className="ecx-survey-preview__answer-label">
                                                    <span>{index + 1}.</span> {question.title}
                                                </div>
                                                <div
                                                    className={`ecx-survey-preview__answer-value${
                                                        hasValue ? '' : ' is-empty'
                                                    }`}
                                                >
                                                    {hasValue
                                                        ? Array.isArray(value)
                                                            ? value.join(', ')
                                                            : String(value)
                                                        : 'Not answered'}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <pre className="ecx-survey-preview__json mb-0">
                                    {JSON.stringify(submittedData, null, 2)}
                                </pre>
                            )}
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default SubmitMessage;
